var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeezer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Deezer",
    role: "img",
    fill: "none",
    strokeWidth: 20,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: "15%",
    fill: "#231f20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#f1796e",
    d: "M78 241h64m-64 26h64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ec2529",
    d: "M78 293h64m-64 26h64m-64 26h64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#f6dd05",
    d: "M148 293h64m-64 26h64m-64 26h64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#e78dcc",
    d: "M218 241h64m-64 26h64m-64-52h64m-64-26h64"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d81996",
    d: "M218 293h64m-64 26h64m-64 26h64"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d6e465",
    d: "M288 241h64m-64 26h64"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#adda1a",
    d: "M288 293h64m-64 26h64m-64 26h64"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b0d8e6",
    d: "M358 241h64m-64 26h64m-64-52h64m-64-26h64m-64-26h64"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#56bbe9",
    d: "M358 293h64m-64 26h64m-64 26h64"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeezer);
export default __webpack_public_path__ + "static/media/deezer.07d4fb81dc04c806eb8d93a1cc1fce24.svg";
export { ForwardRef as ReactComponent };